// source: imports/ecom/order_line.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb =
    require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var imports_options_event_metadata_pb =
    require('../../imports/options/event_metadata_pb.js');
goog.object.extend(proto, imports_options_event_metadata_pb);
goog.exportSymbol('proto.com.chegg.rio.backend.ecom.OrderLine', null, global);
goog.exportSymbol(
    'proto.com.chegg.rio.backend.ecom.RecurringType', null, global);
goog.exportSymbol(
    'proto.com.chegg.rio.backend.ecom.TaxComponent', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.chegg.rio.backend.ecom.TaxComponent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.com.chegg.rio.backend.ecom.TaxComponent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.chegg.rio.backend.ecom.TaxComponent.displayName =
      'proto.com.chegg.rio.backend.ecom.TaxComponent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.com.chegg.rio.backend.ecom.OrderLine = function(opt_data) {
  jspb.Message.initialize(
      this, opt_data, 0, -1,
      proto.com.chegg.rio.backend.ecom.OrderLine.repeatedFields_, null);
};
goog.inherits(proto.com.chegg.rio.backend.ecom.OrderLine, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.com.chegg.rio.backend.ecom.OrderLine.displayName =
      'proto.com.chegg.rio.backend.ecom.OrderLine';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.toObject = function(
      opt_includeInstance) {
    return proto.com.chegg.rio.backend.ecom.TaxComponent.toObject(
        opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.chegg.rio.backend.ecom.TaxComponent} msg The msg
   *     instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.chegg.rio.backend.ecom.TaxComponent.toObject = function(
      includeInstance, msg) {
    var f, obj = {
      taxKey: jspb.Message.getFieldWithDefault(msg, 200, ''),
      taxAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 201, 0.0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.chegg.rio.backend.ecom.TaxComponent}
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.deserializeBinary = function(
    bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.chegg.rio.backend.ecom.TaxComponent;
  return proto.com.chegg.rio.backend.ecom.TaxComponent
      .deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.chegg.rio.backend.ecom.TaxComponent} msg The message
 *     object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.chegg.rio.backend.ecom.TaxComponent}
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.deserializeBinaryFromReader =
    function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 200:
        var value = /** @type {string} */ (reader.readString());
        msg.setTaxKey(value);
        break;
      case 201:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setTaxAmount(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.serializeBinary =
    function() {
  var writer = new jspb.BinaryWriter();
  proto.com.chegg.rio.backend.ecom.TaxComponent.serializeBinaryToWriter(
      this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.chegg.rio.backend.ecom.TaxComponent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.serializeBinaryToWriter =
    function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 200));
  if (f != null) {
    writer.writeString(200, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 201));
  if (f != null) {
    writer.writeFloat(201, f);
  }
};


/**
 * optional string tax_key = 200;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.getTaxKey = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 200, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.TaxComponent} returns this
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.setTaxKey = function(
    value) {
  return jspb.Message.setField(this, 200, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.TaxComponent} returns this
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.clearTaxKey =
    function() {
  return jspb.Message.setField(this, 200, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.hasTaxKey = function() {
  return jspb.Message.getField(this, 200) != null;
};


/**
 * optional float tax_amount = 201;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.getTaxAmount =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 201, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.TaxComponent} returns this
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.setTaxAmount = function(
    value) {
  return jspb.Message.setField(this, 201, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.TaxComponent} returns this
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.clearTaxAmount =
    function() {
  return jspb.Message.setField(this, 201, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.TaxComponent.prototype.hasTaxAmount =
    function() {
  return jspb.Message.getField(this, 201) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.com.chegg.rio.backend.ecom.OrderLine.repeatedFields_ = [226];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.com.chegg.rio.backend.ecom.OrderLine.prototype.toObject = function(
      opt_includeInstance) {
    return proto.com.chegg.rio.backend.ecom.OrderLine.toObject(
        opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.com.chegg.rio.backend.ecom.OrderLine} msg The msg instance
   *     to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.com.chegg.rio.backend.ecom.OrderLine.toObject = function(
      includeInstance, msg) {
    var f, obj = {
      orderLineId: jspb.Message.getFieldWithDefault(msg, 200, 0),
      itemId: jspb.Message.getFieldWithDefault(msg, 201, 0),
      productId: jspb.Message.getFieldWithDefault(msg, 202, ''),
      itemProductFamily: jspb.Message.getFieldWithDefault(msg, 203, ''),
      itemRecurringType: jspb.Message.getFieldWithDefault(msg, 204, 0),
      referringPartner: jspb.Message.getFieldWithDefault(msg, 205, ''),
      subscriptionId: jspb.Message.getFieldWithDefault(msg, 206, 0),
      itemIsTrial: jspb.Message.getBooleanFieldWithDefault(msg, 207, false),
      itemTrialLength: jspb.Message.getFieldWithDefault(msg, 208, 0),
      bundleId: jspb.Message.getFieldWithDefault(msg, 209, ''),
      itemSubtotal:
          jspb.Message.getFloatingPointFieldWithDefault(msg, 210, 0.0),
      itemTaxPaid: jspb.Message.getFloatingPointFieldWithDefault(msg, 211, 0.0),
      itemTotal: jspb.Message.getFloatingPointFieldWithDefault(msg, 212, 0.0),
      transactionType: jspb.Message.getFieldWithDefault(msg, 213, ''),
      itemEan: jspb.Message.getFieldWithDefault(msg, 214, 0),
      vertexProductClassId: jspb.Message.getFieldWithDefault(msg, 215, ''),
      itemStartDate: (f = msg.getItemStartDate()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      itemEndDate: (f = msg.getItemEndDate()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      itemBesp: jspb.Message.getFloatingPointFieldWithDefault(msg, 218, 0.0),
      itemBasePrice:
          jspb.Message.getFloatingPointFieldWithDefault(msg, 219, 0.0),
      warrantyDays: jspb.Message.getFieldWithDefault(msg, 220, 0),
      itemRefundAmount:
          jspb.Message.getFloatingPointFieldWithDefault(msg, 221, 0.0),
      imageUrl: jspb.Message.getFieldWithDefault(msg, 222, ''),
      isbnTitle: jspb.Message.getFieldWithDefault(msg, 223, ''),
      accessExpirationDate: (f = msg.getAccessExpirationDate()) &&
          google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
      renewalPeriodUnit: jspb.Message.getFieldWithDefault(msg, 225, ''),
      taxComponentsList: jspb.Message.toObjectList(
          msg.getTaxComponentsList(),
          proto.com.chegg.rio.backend.ecom.TaxComponent.toObject,
          includeInstance),
      cheggAceOfferId: jspb.Message.getFieldWithDefault(msg, 227, ''),
      orderPlacedBy: jspb.Message.getFieldWithDefault(msg, 228, ''),
      renewalPeriodValue: jspb.Message.getFieldWithDefault(msg, 229, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.com.chegg.rio.backend.ecom.OrderLine;
  return proto.com.chegg.rio.backend.ecom.OrderLine.deserializeBinaryFromReader(
      msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.com.chegg.rio.backend.ecom.OrderLine} msg The message object
 *     to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.deserializeBinaryFromReader =
    function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 200:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setOrderLineId(value);
        break;
      case 201:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setItemId(value);
        break;
      case 202:
        var value = /** @type {string} */ (reader.readString());
        msg.setProductId(value);
        break;
      case 203:
        var value = /** @type {string} */ (reader.readString());
        msg.setItemProductFamily(value);
        break;
      case 204:
        var value =
            /** @type {!proto.com.chegg.rio.backend.ecom.RecurringType} */ (
                reader.readEnum());
        msg.setItemRecurringType(value);
        break;
      case 205:
        var value = /** @type {string} */ (reader.readString());
        msg.setReferringPartner(value);
        break;
      case 206:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setSubscriptionId(value);
        break;
      case 207:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setItemIsTrial(value);
        break;
      case 208:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setItemTrialLength(value);
        break;
      case 209:
        var value = /** @type {string} */ (reader.readString());
        msg.setBundleId(value);
        break;
      case 210:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setItemSubtotal(value);
        break;
      case 211:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setItemTaxPaid(value);
        break;
      case 212:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setItemTotal(value);
        break;
      case 213:
        var value = /** @type {string} */ (reader.readString());
        msg.setTransactionType(value);
        break;
      case 214:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setItemEan(value);
        break;
      case 215:
        var value = /** @type {string} */ (reader.readString());
        msg.setVertexProductClassId(value);
        break;
      case 216:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setItemStartDate(value);
        break;
      case 217:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setItemEndDate(value);
        break;
      case 218:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setItemBesp(value);
        break;
      case 219:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setItemBasePrice(value);
        break;
      case 220:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setWarrantyDays(value);
        break;
      case 221:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setItemRefundAmount(value);
        break;
      case 222:
        var value = /** @type {string} */ (reader.readString());
        msg.setImageUrl(value);
        break;
      case 223:
        var value = /** @type {string} */ (reader.readString());
        msg.setIsbnTitle(value);
        break;
      case 224:
        var value = new google_protobuf_timestamp_pb.Timestamp;
        reader.readMessage(
            value,
            google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
        msg.setAccessExpirationDate(value);
        break;
      case 225:
        var value = /** @type {string} */ (reader.readString());
        msg.setRenewalPeriodUnit(value);
        break;
      case 226:
        var value = new proto.com.chegg.rio.backend.ecom.TaxComponent;
        reader.readMessage(
            value,
            proto.com.chegg.rio.backend.ecom.TaxComponent
                .deserializeBinaryFromReader);
        msg.addTaxComponents(value);
        break;
      case 227:
        var value = /** @type {string} */ (reader.readString());
        msg.setCheggAceOfferId(value);
        break;
      case 228:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrderPlacedBy(value);
        break;
      case 229:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setRenewalPeriodValue(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.serializeBinary =
    function() {
  var writer = new jspb.BinaryWriter();
  proto.com.chegg.rio.backend.ecom.OrderLine.serializeBinaryToWriter(
      this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.com.chegg.rio.backend.ecom.OrderLine} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.com.chegg.rio.backend.ecom.OrderLine.serializeBinaryToWriter = function(
    message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 200));
  if (f != null) {
    writer.writeInt64(200, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 201));
  if (f != null) {
    writer.writeInt64(201, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 202));
  if (f != null) {
    writer.writeString(202, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 203));
  if (f != null) {
    writer.writeString(203, f);
  }
  f = /** @type {!proto.com.chegg.rio.backend.ecom.RecurringType} */ (
      jspb.Message.getField(message, 204));
  if (f != null) {
    writer.writeEnum(204, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 205));
  if (f != null) {
    writer.writeString(205, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 206));
  if (f != null) {
    writer.writeInt64(206, f);
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 207));
  if (f != null) {
    writer.writeBool(207, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 208));
  if (f != null) {
    writer.writeInt64(208, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 209));
  if (f != null) {
    writer.writeString(209, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 210));
  if (f != null) {
    writer.writeFloat(210, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 211));
  if (f != null) {
    writer.writeFloat(211, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 212));
  if (f != null) {
    writer.writeFloat(212, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 213));
  if (f != null) {
    writer.writeString(213, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 214));
  if (f != null) {
    writer.writeInt64(214, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 215));
  if (f != null) {
    writer.writeString(215, f);
  }
  f = message.getItemStartDate();
  if (f != null) {
    writer.writeMessage(
        216, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = message.getItemEndDate();
  if (f != null) {
    writer.writeMessage(
        217, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 218));
  if (f != null) {
    writer.writeFloat(218, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 219));
  if (f != null) {
    writer.writeFloat(219, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 220));
  if (f != null) {
    writer.writeInt64(220, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 221));
  if (f != null) {
    writer.writeFloat(221, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 222));
  if (f != null) {
    writer.writeString(222, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 223));
  if (f != null) {
    writer.writeString(223, f);
  }
  f = message.getAccessExpirationDate();
  if (f != null) {
    writer.writeMessage(
        224, f, google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 225));
  if (f != null) {
    writer.writeString(225, f);
  }
  f = message.getTaxComponentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
        226, f,
        proto.com.chegg.rio.backend.ecom.TaxComponent.serializeBinaryToWriter);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 227));
  if (f != null) {
    writer.writeString(227, f);
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 228));
  if (f != null) {
    writer.writeString(228, f);
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 229));
  if (f != null) {
    writer.writeInt32(229, f);
  }
};


/**
 * optional int64 order_line_id = 200;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getOrderLineId =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 200, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setOrderLineId = function(
    value) {
  return jspb.Message.setField(this, 200, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearOrderLineId =
    function() {
  return jspb.Message.setField(this, 200, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasOrderLineId =
    function() {
  return jspb.Message.getField(this, 200) != null;
};


/**
 * optional int64 item_id = 201;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 201, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemId = function(
    value) {
  return jspb.Message.setField(this, 201, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemId = function() {
  return jspb.Message.setField(this, 201, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemId = function() {
  return jspb.Message.getField(this, 201) != null;
};


/**
 * optional string product_id = 202;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getProductId = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 202, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setProductId = function(
    value) {
  return jspb.Message.setField(this, 202, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearProductId =
    function() {
  return jspb.Message.setField(this, 202, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasProductId = function() {
  return jspb.Message.getField(this, 202) != null;
};


/**
 * optional string item_product_family = 203;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemProductFamily =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 203, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemProductFamily =
    function(value) {
  return jspb.Message.setField(this, 203, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemProductFamily =
    function() {
  return jspb.Message.setField(this, 203, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemProductFamily =
    function() {
  return jspb.Message.getField(this, 203) != null;
};


/**
 * optional RecurringType item_recurring_type = 204;
 * @return {!proto.com.chegg.rio.backend.ecom.RecurringType}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemRecurringType =
    function() {
  return /** @type {!proto.com.chegg.rio.backend.ecom.RecurringType} */ (
      jspb.Message.getFieldWithDefault(this, 204, 0));
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.RecurringType} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemRecurringType =
    function(value) {
  return jspb.Message.setField(this, 204, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemRecurringType =
    function() {
  return jspb.Message.setField(this, 204, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemRecurringType =
    function() {
  return jspb.Message.getField(this, 204) != null;
};


/**
 * optional string referring_partner = 205;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getReferringPartner =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 205, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setReferringPartner =
    function(value) {
  return jspb.Message.setField(this, 205, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearReferringPartner =
    function() {
  return jspb.Message.setField(this, 205, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasReferringPartner =
    function() {
  return jspb.Message.getField(this, 205) != null;
};


/**
 * optional int64 subscription_id = 206;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getSubscriptionId =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 206, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setSubscriptionId =
    function(value) {
  return jspb.Message.setField(this, 206, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearSubscriptionId =
    function() {
  return jspb.Message.setField(this, 206, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasSubscriptionId =
    function() {
  return jspb.Message.getField(this, 206) != null;
};


/**
 * optional bool item_is_trial = 207;
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemIsTrial =
    function() {
  return /** @type {boolean} */ (
      jspb.Message.getBooleanFieldWithDefault(this, 207, false));
};


/**
 * @param {boolean} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemIsTrial = function(
    value) {
  return jspb.Message.setField(this, 207, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemIsTrial =
    function() {
  return jspb.Message.setField(this, 207, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemIsTrial =
    function() {
  return jspb.Message.getField(this, 207) != null;
};


/**
 * optional int64 item_trial_length = 208;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemTrialLength =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 208, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemTrialLength =
    function(value) {
  return jspb.Message.setField(this, 208, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemTrialLength =
    function() {
  return jspb.Message.setField(this, 208, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemTrialLength =
    function() {
  return jspb.Message.getField(this, 208) != null;
};


/**
 * optional string bundle_id = 209;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getBundleId = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 209, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setBundleId = function(
    value) {
  return jspb.Message.setField(this, 209, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearBundleId =
    function() {
  return jspb.Message.setField(this, 209, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasBundleId = function() {
  return jspb.Message.getField(this, 209) != null;
};


/**
 * optional float item_subtotal = 210;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemSubtotal =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 210, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemSubtotal = function(
    value) {
  return jspb.Message.setField(this, 210, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemSubtotal =
    function() {
  return jspb.Message.setField(this, 210, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemSubtotal =
    function() {
  return jspb.Message.getField(this, 210) != null;
};


/**
 * optional float item_tax_paid = 211;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemTaxPaid =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 211, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemTaxPaid = function(
    value) {
  return jspb.Message.setField(this, 211, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemTaxPaid =
    function() {
  return jspb.Message.setField(this, 211, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemTaxPaid =
    function() {
  return jspb.Message.getField(this, 211) != null;
};


/**
 * optional float item_total = 212;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemTotal = function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 212, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemTotal = function(
    value) {
  return jspb.Message.setField(this, 212, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemTotal =
    function() {
  return jspb.Message.setField(this, 212, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemTotal = function() {
  return jspb.Message.getField(this, 212) != null;
};


/**
 * optional string transaction_type = 213;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getTransactionType =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 213, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setTransactionType =
    function(value) {
  return jspb.Message.setField(this, 213, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearTransactionType =
    function() {
  return jspb.Message.setField(this, 213, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasTransactionType =
    function() {
  return jspb.Message.getField(this, 213) != null;
};


/**
 * optional int64 item_ean = 214;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemEan = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 214, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemEan = function(
    value) {
  return jspb.Message.setField(this, 214, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemEan = function() {
  return jspb.Message.setField(this, 214, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemEan = function() {
  return jspb.Message.getField(this, 214) != null;
};


/**
 * optional string vertex_product_class_id = 215;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getVertexProductClassId =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 215, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setVertexProductClassId =
    function(value) {
  return jspb.Message.setField(this, 215, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearVertexProductClassId =
    function() {
  return jspb.Message.setField(this, 215, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasVertexProductClassId =
    function() {
  return jspb.Message.getField(this, 215) != null;
};


/**
 * optional google.protobuf.Timestamp item_start_date = 216;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemStartDate =
    function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 216));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemStartDate =
    function(value) {
  return jspb.Message.setWrapperField(this, 216, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemStartDate =
    function() {
  return this.setItemStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemStartDate =
    function() {
  return jspb.Message.getField(this, 216) != null;
};


/**
 * optional google.protobuf.Timestamp item_end_date = 217;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemEndDate =
    function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 217));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemEndDate = function(
    value) {
  return jspb.Message.setWrapperField(this, 217, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemEndDate =
    function() {
  return this.setItemEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemEndDate =
    function() {
  return jspb.Message.getField(this, 217) != null;
};


/**
 * optional float item_besp = 218;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemBesp = function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 218, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemBesp = function(
    value) {
  return jspb.Message.setField(this, 218, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemBesp =
    function() {
  return jspb.Message.setField(this, 218, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemBesp = function() {
  return jspb.Message.getField(this, 218) != null;
};


/**
 * optional float item_base_price = 219;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemBasePrice =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 219, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemBasePrice =
    function(value) {
  return jspb.Message.setField(this, 219, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemBasePrice =
    function() {
  return jspb.Message.setField(this, 219, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemBasePrice =
    function() {
  return jspb.Message.getField(this, 219) != null;
};


/**
 * optional int64 warranty_days = 220;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getWarrantyDays =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 220, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setWarrantyDays = function(
    value) {
  return jspb.Message.setField(this, 220, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearWarrantyDays =
    function() {
  return jspb.Message.setField(this, 220, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasWarrantyDays =
    function() {
  return jspb.Message.getField(this, 220) != null;
};


/**
 * optional float item_refund_amount = 221;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getItemRefundAmount =
    function() {
  return /** @type {number} */ (
      jspb.Message.getFloatingPointFieldWithDefault(this, 221, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setItemRefundAmount =
    function(value) {
  return jspb.Message.setField(this, 221, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearItemRefundAmount =
    function() {
  return jspb.Message.setField(this, 221, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasItemRefundAmount =
    function() {
  return jspb.Message.getField(this, 221) != null;
};


/**
 * optional string image_url = 222;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getImageUrl = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 222, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setImageUrl = function(
    value) {
  return jspb.Message.setField(this, 222, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearImageUrl =
    function() {
  return jspb.Message.setField(this, 222, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasImageUrl = function() {
  return jspb.Message.getField(this, 222) != null;
};


/**
 * optional string isbn_title = 223;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getIsbnTitle = function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 223, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setIsbnTitle = function(
    value) {
  return jspb.Message.setField(this, 223, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearIsbnTitle =
    function() {
  return jspb.Message.setField(this, 223, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasIsbnTitle = function() {
  return jspb.Message.getField(this, 223) != null;
};


/**
 * optional google.protobuf.Timestamp access_expiration_date = 224;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getAccessExpirationDate =
    function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
      jspb.Message.getWrapperField(
          this, google_protobuf_timestamp_pb.Timestamp, 224));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setAccessExpirationDate =
    function(value) {
  return jspb.Message.setWrapperField(this, 224, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearAccessExpirationDate =
    function() {
  return this.setAccessExpirationDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasAccessExpirationDate =
    function() {
  return jspb.Message.getField(this, 224) != null;
};


/**
 * optional string renewal_period_unit = 225;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getRenewalPeriodUnit =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 225, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setRenewalPeriodUnit =
    function(value) {
  return jspb.Message.setField(this, 225, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearRenewalPeriodUnit =
    function() {
  return jspb.Message.setField(this, 225, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasRenewalPeriodUnit =
    function() {
  return jspb.Message.getField(this, 225) != null;
};


/**
 * repeated TaxComponent tax_components = 226;
 * @return {!Array<!proto.com.chegg.rio.backend.ecom.TaxComponent>}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getTaxComponentsList =
    function() {
  return /** @type{!Array<!proto.com.chegg.rio.backend.ecom.TaxComponent>} */ (
      jspb.Message.getRepeatedWrapperField(
          this, proto.com.chegg.rio.backend.ecom.TaxComponent, 226));
};


/**
 * @param {!Array<!proto.com.chegg.rio.backend.ecom.TaxComponent>} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setTaxComponentsList =
    function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 226, value);
};


/**
 * @param {!proto.com.chegg.rio.backend.ecom.TaxComponent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.com.chegg.rio.backend.ecom.TaxComponent}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.addTaxComponents =
    function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(
      this, 226, opt_value, proto.com.chegg.rio.backend.ecom.TaxComponent,
      opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearTaxComponentsList =
    function() {
  return this.setTaxComponentsList([]);
};


/**
 * optional string chegg_ace_offer_id = 227;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getCheggAceOfferId =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 227, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setCheggAceOfferId =
    function(value) {
  return jspb.Message.setField(this, 227, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearCheggAceOfferId =
    function() {
  return jspb.Message.setField(this, 227, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasCheggAceOfferId =
    function() {
  return jspb.Message.getField(this, 227) != null;
};


/**
 * optional string order_placed_by = 228;
 * @return {string}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getOrderPlacedBy =
    function() {
  return /** @type {string} */ (
      jspb.Message.getFieldWithDefault(this, 228, ''));
};


/**
 * @param {string} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setOrderPlacedBy =
    function(value) {
  return jspb.Message.setField(this, 228, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearOrderPlacedBy =
    function() {
  return jspb.Message.setField(this, 228, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasOrderPlacedBy =
    function() {
  return jspb.Message.getField(this, 228) != null;
};


/**
 * optional int32 renewal_period_value = 229;
 * @return {number}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.getRenewalPeriodValue =
    function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 229, 0));
};


/**
 * @param {number} value
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.setRenewalPeriodValue =
    function(value) {
  return jspb.Message.setField(this, 229, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.com.chegg.rio.backend.ecom.OrderLine} returns this
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.clearRenewalPeriodValue =
    function() {
  return jspb.Message.setField(this, 229, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.com.chegg.rio.backend.ecom.OrderLine.prototype.hasRenewalPeriodValue =
    function() {
  return jspb.Message.getField(this, 229) != null;
};


/**
 * @enum {number}
 */
proto.com.chegg.rio.backend.ecom.RecurringType = {
  UNKNOWN_RECURRINGTYPE: 0,
  RECURRING: 1,
  NON_RECURRING: 2
};

goog.object.extend(exports, proto.com.chegg.rio.backend.ecom);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/ecom/order_line_pb.js
// module id = 4328
// module chunks = 11